import Keycloak from "keycloak-js/dist/keycloak.js";
import { persistOfflineToken } from "utils/common";
import { UPDATE_TOKEN_INTERVAL } from "config/constants";

export const KEYCLOAK_SCOPE = "openid offline_access bm-api email profile";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_AUTH_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM as string,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string,
});

keycloak.onAuthSuccess = () => {
    if (keycloak.refreshToken) {
        persistOfflineToken(keycloak.refreshToken);
    }
};

keycloak.onAuthRefreshSuccess = () => {
    if (keycloak.refreshToken) {
        persistOfflineToken(keycloak.refreshToken);
    }
};

keycloak.onAuthError = function (errorData) {
    console.error("Authentication error:", errorData);
};

keycloak.onAuthRefreshError = function () {
    console.error("Failed to refresh token");
    // You might want to force a logout here if the refresh fails
    // keycloak.logout();
};

keycloak.onTokenExpired = function () {
    console.log("Token expired, attempting to refresh...");
    keycloak.updateToken(UPDATE_TOKEN_INTERVAL).catch(() => {
        console.error("Failed to refresh expired token");
        // keycloak.clearToken();
    });
};

export default keycloak;
